<template>
  <v-app class="white">
    <Navbar />
    <v-content class>
      <router-view></router-view>
    </v-content>
    <Footer />
  </v-app>
</template>
<script>
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default {
  components: { Navbar, Footer },
  name: "App",
  data() {
    return {
      logged: false,
      snackbar: true,
      y: "bottom",
      x: null,
      mode: "",
      affiliate:
        "This website promotes products sold by external websites, when you click on some of the links on the website, you may be directed to external websites and we may earn a commission for the services you buy from the website you are directed to.",
      timeout: 6000,
      text:
        "We use cookies and other technologies to keep the site reliable and secure, tailor your experience, measure site performance and present relevant offers and advertisements, as described in our privacy policy and cookie policy."
    };
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
  }
};
</script>
